import type { Element } from 'slate';

import { createParagraphNode } from './text';

export const createTableNode = (rowCount = 2, cellCount = 2): Element => ({
  type: 'table',
  columns: Array.from(
    {
      length: cellCount,
    },
    () => ({
      width: 100,
    }),
  ),
  children: [
    createTableBodyNode(rowCount, cellCount),
  ],
});

export const createTableBodyNode = (rowCount = 2, cellCount = 2): Element => ({
  type: 'table-body',
  children: Array.from(
    {
      length: rowCount,
    },
    () => createTableRowNode(cellCount),
  ),
});

export const createTableRowNode = (cellCount = 2): Element => ({
  type: 'table-row',
  children: Array.from(
    {
      length: cellCount,
    },
    () => createTableCellNode(),
  ),
});

export const createTableCellNode = (): Element => ({
  type: 'table-cell',
  children: [
    createParagraphNode(),
  ],
});
